module.exports = __webpack_public_path__ + "dist/media/logo--da.6c8e3619.svg";